// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumEnvironmentOperationType } from './EnumEnvironmentOperationType';
import {
  EnumEnvironmentOperationTypeFromJSON,
  EnumEnvironmentOperationTypeFromJSONTyped,
  EnumEnvironmentOperationTypeToJSON,
  EnumEnvironmentOperationTypeToJSONTyped,
} from './EnumEnvironmentOperationType';
import type { EnumEnvironmentOperationStatus } from './EnumEnvironmentOperationStatus';
import {
  EnumEnvironmentOperationStatusFromJSON,
  EnumEnvironmentOperationStatusFromJSONTyped,
  EnumEnvironmentOperationStatusToJSON,
  EnumEnvironmentOperationStatusToJSONTyped,
} from './EnumEnvironmentOperationStatus';

/**
 *
 * @export
 * @interface ResponseEnvironmentStatusOperation
 */
export interface ResponseEnvironmentStatusOperation {
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusOperation
   */
  completedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusOperation
   */
  createdAt?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentStatusOperation
   */
  githubWorkflowRunId?: number;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentStatusOperation
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusOperation
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusOperation
   */
  name?: string;
  /**
   *
   * @type {EnumEnvironmentOperationStatus}
   * @memberof ResponseEnvironmentStatusOperation
   */
  status?: EnumEnvironmentOperationStatus;
  /**
   *
   * @type {EnumEnvironmentOperationType}
   * @memberof ResponseEnvironmentStatusOperation
   */
  type?: EnumEnvironmentOperationType;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentStatusOperation
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentStatusOperation interface.
 */
export function instanceOfResponseEnvironmentStatusOperation(
  value: object,
): value is ResponseEnvironmentStatusOperation {
  return true;
}

export function ResponseEnvironmentStatusOperationFromJSON(
  json: any,
): ResponseEnvironmentStatusOperation {
  return ResponseEnvironmentStatusOperationFromJSONTyped(json, false);
}

export function ResponseEnvironmentStatusOperationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentStatusOperation {
  if (json == null) {
    return json;
  }
  return {
    completedAt:
      json['completed_at'] == null ? undefined : json['completed_at'],
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    githubWorkflowRunId:
      json['github_workflow_run_id'] == null
        ? undefined
        : json['github_workflow_run_id'],
    id: json['id'] == null ? undefined : json['id'],
    message: json['message'] == null ? undefined : json['message'],
    name: json['name'] == null ? undefined : json['name'],
    status:
      json['status'] == null
        ? undefined
        : EnumEnvironmentOperationStatusFromJSON(json['status']),
    type:
      json['type'] == null
        ? undefined
        : EnumEnvironmentOperationTypeFromJSON(json['type']),
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ResponseEnvironmentStatusOperationToJSON(
  json: any,
): ResponseEnvironmentStatusOperation {
  return ResponseEnvironmentStatusOperationToJSONTyped(json, false);
}

export function ResponseEnvironmentStatusOperationToJSONTyped(
  value?: ResponseEnvironmentStatusOperation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    completed_at: value['completedAt'],
    created_at: value['createdAt'],
    github_workflow_run_id: value['githubWorkflowRunId'],
    id: value['id'],
    message: value['message'],
    name: value['name'],
    status: EnumEnvironmentOperationStatusToJSON(value['status']),
    type: EnumEnvironmentOperationTypeToJSON(value['type']),
    updated_at: value['updatedAt'],
  };
}
